import React, { useState, useEffect, useRef, useMemo } from "react";
import { PanelGroup, Panel, PanelResizeHandle } from "react-resizable-panels"
import useInterval from "../Hooks/useInterval";
import mapboxgl from "mapbox-gl";
import "./Home.css";
import SearchIcon from "@mui/icons-material/Search";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import {
  Alert,
  AppBar,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Menu,
  MenuItem,
  TableCell,
  TableRow,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import { CartRow, device_floor_level } from "../components/map_components/CartRow";
import TableHeader from "../components/map_components/TableHeader";
import configData from "../config.json";
import CheckBox from "@mui/material/Checkbox";
//toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";
import ActiveDevices from "../components/map_components/ActiveDevices";
import { getToken } from "../utils/auth"
import { getComparator } from "../functions/sort_function.js"
mapboxgl.accessToken =
  "pk.eyJ1IjoibmVzdGVhcGVhY2giLCJhIjoiY2xid2d1cDZsMTA1djNvdDBsOWtldjVjbSJ9.dlFWnXRPAbPdVPWXs-I_Rg";
//search functions
const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.black, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.black, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));




const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));




function Home() {

  const params = useParams();
  const navigate = useNavigate();
  const [coordinates, setcoordinates] = useState(null);
  const [branch_map_data, setBranchcoordinates] = useState(null);
  const [lng, setLng] = useState(null);
  const [lat, setLat] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res1 = await fetch(`${configData.SERVER_URL}/BranchMap`);
        const branchData = await res1.json();
        setBranchcoordinates(branchData.data);

        const res2 = await fetch(`${configData.SERVER_URL}/coordinateMap`);
        const coordData = await res2.json();
        setcoordinates(coordData.data);

        const selectedStoreCoordinates =
          coordData?.data?.[params?.retailer]?.[params?.store];
        if (!selectedStoreCoordinates) {
          console.error(
            `Missing coordinate map for retailer ${params?.retailer}, store ${params?.store}`
          );
          return;
        }

        setLng(selectedStoreCoordinates.lng);
        setLat(selectedStoreCoordinates.lat);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [params?.retailer, params?.store]);

  const [floor, setFloor] = useState("***");
  useEffect(() => {
    changeFloor("***")
  },
    []);
  const selectedStoreCoordinates = coordinates?.[params?.retailer]?.[params?.store];
  const selectedBranchMapData = branch_map_data?.[params?.retailer]?.[params?.store];
  //cart event updating every minute by set interval
  const [cartEvents, setCartEvents] = useState([
    {
      sdkSetupId: "Yaniv-Tablet",
      ts: "2023-01-02T10:08:26.720Z",
      lat: "32.11385724354644",
      lon: "34.84136531128797",
      color: "#FF5722",
      scale: 1,
      device_id: "686181075b61c64a",
      serial_number: "Loading...",
      mdm_id: "15",
      last_location: "השלושה 2 תל אביב",
      mdm_lat: "",
      mdm_lon: "",
      last_location_time: "",
      wifi: "none",
      battery: "none",
      battery_ts: "none",
      mdm_location: false,
      floor_level: 0
    },
  ]);
  const mapContainerRef = useRef(null);
  const map = useRef(null);
  const [zoom, setZoom] = useState(18.9);
  const [markers, setMarkers] = useState([]);
  const [selcted, setSelcted] = useState({
    sdk: "",
    marked: false,
  });
  const notify = (message, style) => {
    if (style === "success") {
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  //serach bar
  const [searchCart, setSearchCart] = useState("");
  const [updateTimer, setUpdateTimer] = useState(60);

  //table sort states:
  const [orderDirection, setOrderDirection] = useState("asc");
  const [valueToOrderBy, setValueToOrderBy] = useState("serial_number");
  //table check box

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = filteredCarts.map((n) => n.serial_number);
      setChecked(newSelected);
      return;
    }
    setChecked([]);
  };

  const handleClick = (event, serial_number) => {
    const selectedIndex = checked.indexOf(serial_number);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(checked, serial_number);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(checked.slice(1));
    } else if (selectedIndex === checked.length - 1) {
      newSelected = newSelected.concat(checked.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        checked.slice(0, selectedIndex),
        checked.slice(selectedIndex + 1)
      );
    }
    setChecked(newSelected);
  };
  const [checked, setChecked] = useState([]);
  const [swanSongTrigger, setswanSongTrigger] = useState(false);
  const [triggeredSwanSong, setTriggeredSwanSong] = useState([])

  const handleSwanSongClick = () => {
    const token = getToken()
    let newBody = {
      tablets: checked,
      message: "Trigger swan song",
    };
    fetch(`${configData.SERVER_URL}/Trigger/SwanSong`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setTriggeredSwanSong(checked)
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  };

  useEffect(() => {
    if (swanSongTrigger) {
      handleSwanSongClick()
      setswanSongTrigger(false)
    }
  }, [swanSongTrigger]);

  const isSelected = (serial_number) => checked.indexOf(serial_number) !== -1;
  const wasTriggered = (serial_number) => triggeredSwanSong.indexOf(serial_number) !== -1;

  const changeSelectedCart = (serial_number, color) => {
    let newList = cartEvents.map((cart) => {
      if (
        selcted.marked === true &&
        selcted.sdk === cart.serial_number &&
        selcted.sdk !== serial_number
      ) {
        return {
          ...cart,

          color: "#2980B9",
        };
      }
      if (cart.serial_number === serial_number) {
        setSelcted({ sdk: serial_number, marked: true });
        return {
          ...cart,
          color: color,
          scale: 1,
        };
      }
      return cart;
    });
    setCartEvents(newList);
  };
  //Columns control
  const [anchorElColumns, setAnchorElColumns] = useState(null);

  const handleOpenColumnsMenu = (event) => {
    setAnchorElColumns(event.currentTarget);
  };

  const handleCloseColumsMenu = () => {
    setAnchorElColumns(null);
  };
  const [columnForm, setColumnForm] = useState({
    serial_number: true,
    battery: false,
    battery_status: false,
    battery_temp: false,
    wifi: false,
    tablet_status: false,
    location_update: true,
    photo: false,
    show_location: true,
    swan_song: true,
    beacon: false,
    cart: true,
  });

  const handleColumnForm = (e) => {
    setColumnForm((prevState) => {
      return { ...prevState, [e.target.name]: e.target.checked };
    });
  };

  //Action menue for multi select:
  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const updateCartEvent = (serial_number, data) => {

    let newList = cartEvents.map((cart) => {

      if (cart.serial_number === serial_number) {
        return {
          ...cart,
          last_location: data.last_location,
          mdm_lat: data.mdm_lat,
          mdm_lon: data.mdm_lon,
          last_location_time: data.last_location_time,
          scale: 1,
        };
      }
      return cart;
    });
    setCartEvents(newList);
  };

  const softResetCart = async () => {
    const token = getToken();

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };

    const body = {
      devices: checked,
    };

    try {
      const response = await fetch(
        `${configData.SERVER_URL}/SoftReset`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(body)
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch location data");
      }

      const data = await response.json();
      console.log(data)
    } catch (error) {
      console.log("Error:", error);
    }
  };


  const [open, setOpen] = useState(false);

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    setOpen(false);
    softResetCart();  // your reset function
  };


  const updateCartLocation = async (serial_number, show) => {
    const token = getToken();

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };

    try {
      const response = await fetch(
        `${configData.SERVER_URL}/GetLocation/${serial_number}`,
        {
          method: "GET",
          headers,
        }
      );

      if (!response.ok) {
        toast.error("❌ Failed to fetch location data"); // ✅ show toast
        return false
      }
      else {
        const data = await response.json();
        if (data.DeviceId) {
          const newList = cartEvents.map((cart) => {
            if (cart.serial_number === serial_number) {
              cart.mdm_lat = data.Latitude
              cart.mdm_lon = data.Longitude
              cart.mdm_location = true
              return {
                ...cart,
              };
            }
            return cart;
          });
          setCartEvents(newList);
        }
        return true
      }

    } catch (error) {
      console.log("Error:", error);
    }
  };

  //counts to 15, every sicle updates wifi, battery and swan
  const [updateCounter, setUpdateCounter] = useState(10);
  const [activeDevicesTrigger, setactiveDevicesTrigger] = useState(false);

  const fetchBattery = async () => {
    const nextUpdateCounter = updateCounter === 10 ? 0 : updateCounter + 1;
    setUpdateCounter(nextUpdateCounter);

    const shouldFetchBattery = nextUpdateCounter % 5 === 0;
    const shouldFetchTemp = nextUpdateCounter % 10 === 0;

    const token = getToken();
    const query = new URLSearchParams({
      retailer: params.retailer,
      store: params.store,
    });
    const batteryUrl = `${configData.SERVER_URL}/FetchBattery?${query.toString()}`;
    const tempUrl = `${configData.SERVER_URL}/FetchBatteryTemp?${query.toString()}`;

    let updatedEvents = [...cartEvents];

    try {
      if (shouldFetchBattery) {
        const batteryRes = await fetch(batteryUrl, {
          method: "GET",
          headers: {
            "x-access-token": token,
          },
        });
        if (!batteryRes.ok) {
          throw new Error(batteryRes.status);
        }
        const batteryData = await batteryRes.json();
        updatedEvents = batteryData.map((cart) => {
          for (let i = 0; i < cartEvents.length; i++) {
            if (cart.serial_number === cartEvents[i].serial_number) {
              return {
                ...cartEvents[i],
                ts: cartEvents[i].ts,
                lat: cartEvents[i].lat,
                lon: cartEvents[i].lon,
                scale: cartEvents[i].scale,
                status: cartEvents[i].status,
                type: cartEvents[i].type,
                wifi: cartEvents[i].wifi,
                floor_level: cartEvents[i].floor_level,
                battery: cart.battery,
                battery_ts: cart.battery_ts,
                status: cart.status,
                battery_status: cart.battery_status,
                journey_status: cart.journey_status,
                battery_temp: cartEvents[i].battery_temp ?? null,
                before_discharging_temp: cartEvents[i].before_discharging_temp ?? null,
              };
            }
          }
          return cart;
        });
        setCartEvents(updatedEvents);
      }

      if (shouldFetchTemp) {
        const tempRes = await fetch(tempUrl, {
          method: "GET",
          headers: {
            "x-access-token": token,
          },
        });
        if (!tempRes.ok) {
          throw new Error(tempRes.status);
        }
        const tempData = await tempRes.json();
        const baseEvents = shouldFetchBattery ? updatedEvents : cartEvents;
        updatedEvents = tempData.map((cart) => {
          for (let i = 0; i < baseEvents.length; i++) {
            if (cart.serial_number === baseEvents[i].serial_number) {
              return {
                ...baseEvents[i],
                ts: baseEvents[i].ts,
                lat: baseEvents[i].lat,
                lon: baseEvents[i].lon,
                scale: baseEvents[i].scale,
                status: baseEvents[i].status,
                type: baseEvents[i].type,
                wifi: baseEvents[i].wifi,
                floor_level: baseEvents[i].floor_level,
                battery: baseEvents[i].battery,
                battery_ts: baseEvents[i].battery_ts,
                status: baseEvents[i].status,
                battery_status: baseEvents[i].battery_status,
                journey_status: baseEvents[i].journey_status,
                battery_temp: cart.battery_temp,
                before_discharging_temp: cart.before_discharging_temp,
              };
            }
          }
          return cart;
        });
        setCartEvents(updatedEvents);
      }

      fetchCarts(updatedEvents);
    } catch (error) {
      if (error.message === "401") {
        navigate("/");
      } else {
        if (error.message === "403") {
          navigate(-1);
        } else {
          notify(error, "error");
        }
      }
    }
  };

  const fetchCarts = (addTempEvents) => {
    const token = getToken()
    const query = new URLSearchParams({
      message: String(updateCounter),
      retailer: params.retailer,
      store: params.store,
    });
    fetch(`${configData.SERVER_URL}/carts_last_events?${query.toString()}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        let fetchedCartEvents = data.map((cart) => {
          for (let i = 0; i < addTempEvents.length; i++) {
            if (cart.serial_number === addTempEvents[i].serial_number) {
              return {
                ...addTempEvents[i],
                ts: cart.ts,
                lat: cart.lat,
                lon: cart.lon,
                scale: cart.scale,
                status: cart.status,
                type: cart.type,
                wifi: cart.wifi,
                floor_level: cart.floor_level,
                battery: addTempEvents[i].battery,
                battery_ts: addTempEvents[i].battery_ts,
                status: addTempEvents[i].status,
                battery_status: addTempEvents[i].battery_status,
                journey_status: addTempEvents[i].journey_status,
                battery_temp: addTempEvents[i].battery_temp,
                before_discharging_temp: addTempEvents[i].before_discharging_temp,
              };
            }
          }
          return cart;
        });
        setCartEvents(fetchedCartEvents);
        setactiveDevicesTrigger(!activeDevicesTrigger)
        // fetchSwansong()

      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  };

  const fetchSwansong = () => {
    if (updateCounter != 0) {
      return
    }
    const token = getToken()
    let newBody = {
      message: updateCounter,
      retailer: params.retailer,
      store: params.store,
    };
    fetch(`${configData.SERVER_URL}/FetchSwansong`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        let addSwansongEvents = data.map((cart) => {
          for (let i = 0; i < cartEvents.length; i++) {
            if (cart.serial_number === cartEvents[i].serial_number) {
              return {
                ...cartEvents[i],
                ts: cart.ts,
                lat: cart.lat,
                lon: cart.lon,
                scale: cart.scale,
                type: cart.type,
                wifi: cart.wifi,
                floor_level: cart.floor_level,
                battery: cart.battery,
                battery_ts: cart.battery_ts,
                status: cart.status,
                battery_status: cart.battery_status,
                journey_status: cart.journey_status,
                battery_temp: cart.battery_temp,
                before_discharging_temp: cart.before_discharging_temp
              };

            } else {
            }
          }
          return cart;
        });
        setCartEvents(addSwansongEvents);
        setactiveDevicesTrigger(!activeDevicesTrigger)
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  };

  useEffect(() => {
    document.title = "Catch Field";
    fetchBattery();
  }, []);
  useInterval(() => {
    setUpdateTimer((prevState) => prevState - 1);
  }, 1000);
  useEffect(() => {
    if (updateTimer === 0) {
      setUpdateTimer(60);
      fetchBattery();
    }
  }, [updateTimer]);

  const filteredCarts = useMemo(() => {
    if (searchCart !== "") {
      return cartEvents.filter((cart) => {
        return cart.serial_number.includes(searchCart.toUpperCase()) &&
          (floor === "***" || parseInt(cart.floor_level) === parseInt(floor));
      });
    } else {
      return cartEvents.filter((cart) => {
        return floor === "***" || parseInt(cart.floor_level) === parseInt(floor);
      });
    }
  }, [cartEvents, searchCart, floor]);

  //table handle sort function:
  const handleRequestSort = (event, property) => {
    const isAscending = valueToOrderBy === property && orderDirection === "asc";
    setValueToOrderBy(property);
    setOrderDirection(isAscending ? "desc" : "asc");
  };

  useEffect(() => {
    if (map.current || !coordinates) return;
    map.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: "mapbox://styles/mapbox/streets-v12",
      center: [lng, lat],
      zoom: zoom,
      bearing: "220",
    });
  }, [coordinates]);

  //update center of the map
  const updateCenter = (mdm_lat, mdm_lon) => {
    map.current.setCenter([mdm_lon, mdm_lat]);
  };

  // image layer to the map
  const [CurrentFloor, setCurrentFloor] = useState(null);
  // image layer to the map
  useEffect(() => {
    if (!map.current || !coordinates) return;

    // Cleanup the layer if it exists before adding a new one
    if (floor != CurrentFloor) {
      setCurrentFloor(floor)
      const removeLayerIfExists = () => {
        if (map.current.getLayer("radar-layer")) {
          map.current.removeLayer("radar-layer");
          map.current.removeSource("radar");
        }
      };

      const handleMapLoad = () => {

        if (!selectedStoreCoordinates) {
          console.error(
            `Missing map coordinates for retailer ${params?.retailer}, store ${params?.store}`
          );
          return;
        }

        removeLayerIfExists(); // Remove the existing layer before adding a new one
        map.current.addSource("radar", {
          type: "image",
          url: selectedStoreCoordinates.url + "/" + floor, // Include floor in the URL
          coordinates: selectedStoreCoordinates.coordinates,
        });
        map.current.addLayer({
          id: "radar-layer",
          type: "raster",
          source: "radar",
          paint: {
            "raster-fade-duration": 0,
          },
        });
      };

      // Listen for map load event and add the layer
      if (map.current.isStyleLoaded()) {
        handleMapLoad();
      } else {
        map.current.on("load", handleMapLoad);
      }

      map.current.on("move", () => {
        setLng(map.current.getCenter().lng.toFixed(4));
        setLat(map.current.getCenter().lat.toFixed(4));
        setZoom(map.current.getZoom().toFixed(2));
      });

      return
    }
    else { return }
  }, [floor, coordinates]);

  //markers layer to the map
  useEffect(() => {
    if (!map.current) return;
    for (let i = markers.length - 1; i >= 0; i--) markers[i].remove();
    setMarkers([]);
    //create default marker
    filteredCarts.map((singleCart) => {
      const markerColor =
        String(singleCart.journey_status).toLowerCase() === "offline"
          ? "#FF0000"
          : singleCart.color;
      const rawLng = singleCart.mdm_location
        ? singleCart.mdm_lon
        : singleCart.lon;
      const rawLat = singleCart.mdm_location
        ? singleCart.mdm_lat
        : singleCart.lat;
      const lngVal = Number(rawLng);
      const latVal = Number(rawLat);
      const lng = Number.isFinite(lngVal) ? lngVal : 0;
      const lat = Number.isFinite(latVal) ? latVal : 0;
      const popup = new mapboxgl.Popup().setHTML(
        "<p>" +
        "<small>" +
        singleCart.serial_number +
        "</small>" +
        "</br>" +
        "</p>"
      );
      const marker = new mapboxgl.Marker({
        color: markerColor,
        scale: singleCart.scale,
      })
        .setLngLat([lng, lat])
        .setPopup(popup);
      marker.addTo(map.current);
      setMarkers((prevState) => {
        return [...prevState, marker];
      });
    });
  }, [filteredCarts, floor]);

  //move to multiselect photoes window:
  const moveToMultiPhotoes = () => {
    if (checked.length === 0) {
      notify("No Selected Devices!", "error");
    } else {
      let serials_string = JSON.stringify(checked);
      let serials_url = btoa(serials_string);
      navigate(
        `/Multi/Photos/` +
        serials_url +
        "/" +
        params.retailer +
        "/" +
        params.store
      );
    }
  };

  //Move to Multi RealTime
  const moveToRealTime = () => {
    if (checked.length === 0) {
      notify("No Selected Devices!", "error");
    } else {
      let serials_string = JSON.stringify(checked);
      let serials_url = btoa(serials_string);

      window.open(
        `/Multi/RealTime/${serials_url}/${params.retailer}/${params.store}`,
        "_blank"
      );
    }
  };
  //Move to wifi report
  const moveToWifiReport = () => {
    if (checked.length === 0) {
      notify("No Selected Devices!", "error");
    } else {
      const token = getToken()
      let serials_string = JSON.stringify(checked);
      let serials_url = btoa(serials_string);
      let swanbody = {
        tablets: checked,
        message: "Trigger search wifi networks",
        retailer: params.retailer,
        store: params.store,
      };
      fetch(`${configData.SERVER_URL}/Trigger/SwanSong`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(swanbody),
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(res.status);
          }
          return res.json();
        })
        .then((data) => {
        })

        .catch((error) => {
          if (error.message === "401") {
            navigate("/");
          } else {
            if (error.message === "403") {
              navigate(-1);
            } else {
              notify(error, "error");
            }
          }
        });
      navigate(
        `/Multi/WiFi-Report/` +
        serials_url +
        "/" +
        params.retailer +
        "/" +
        params.store
      );
    }
  };
  const [isOpen, setIsOpen] = useState(false);
  const changeFloor = (value) => {
    setFloor(value)
  }
  useEffect(() => {
    changeFloor(device_floor_level)
  },
    [device_floor_level]);

  const sortedRowInformation = (rowArray, comparator) => {
    const stabilizedRowArray = rowArray.map((el, index) => [el, index]);
    stabilizedRowArray.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedRowArray.map((el) => el[0]);
  };

  const comparator = useMemo(
    () => getComparator(orderDirection, valueToOrderBy),
    [orderDirection, valueToOrderBy]
  );
  const sortedRows = useMemo(
    () => sortedRowInformation(filteredCarts, comparator),
    [filteredCarts, comparator]
  );



  const [ispermitted, setPermission] = useState(false);
  useEffect(() => {
    const token = getToken()

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };
    fetch(
      `${configData.SERVER_URL}/Permission`,
      { headers }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setPermission(data.auth_user);
      })
      .catch((err) => {
        console.error("Error fetching permission:", err);
      });
  },
    []);

  const isMobile = window.innerWidth < 600;
  return (
    <div className="container-fluid">
      <div className="row" style={{
        height: isMobile ? "100vh" : "100%"
      }}>
        <PanelGroup direction={isMobile ? "vertical" : "horizontal"} style={isMobile ? { padding: 0 } : {}}>
          <Panel defaultSize={40} minSize={1}>
            <div className="col">
              <div ref={mapContainerRef} className="map-container"></div>
              <div className="d-flex align-items-center" id="overlay">
                <button

                  className="btn btn-danger btn-lg me-2"
                  onClick={() => {
                    setUpdateCounter(10);
                    setUpdateTimer(0);
                  }}
                >
                  Update {updateTimer}
                </button>

                <div className="dropdown">
                  <button
                    className="btn btn-secondary dropdown-toggle btn-lg me-2"
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    Select floor
                  </button>
                  {isOpen && (
                    <ul className="dropdown-menu show">
                      {selectedBranchMapData?.floorNumber &&
                        Object.keys(selectedBranchMapData.floorNumber).length > 1 ? (
                        <>
                          {Object.keys(selectedBranchMapData.floorNumber)
                            .sort((a, b) => a - b)
                            .map((floor) => (
                              <li key={floor}>
                                <button className="dropdown-item" onClick={() => changeFloor(floor)}>
                                  {floor}
                                </button>
                              </li>
                            ))}
                          <li className="dropdown-item" onClick={() => changeFloor("***")}>
                            All floors
                          </li>
                        </>
                      ) : (
                        <li className="dropdown-item">0</li>
                      )}
                    </ul>
                  )}
                </div>
              </div>

              <ActiveDevices
                event={cartEvents}
                trigger={activeDevicesTrigger} />
            </div>
          </Panel>
          <PanelResizeHandle className="resize-handle" />
          <Panel minSize={10} maxSize={100} className="bottom-panel">
            <div
              className="col"
              style={{
                height: "100%",          // fill panel
                display: "flex",
                flexDirection: "column",
                minHeight: 0,            // 👈 allow children to shrink
              }}
            >
              <Box sx={{ flexGrow: 0 }}>
                <AppBar position="static" color="primary">
                  <Toolbar>
                    <Typography
                      variant="h6"
                      noWrap
                      component="div"
                      sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
                      onClick={() => {
                        navigate("/Home/" + params.retailer + "/" + params.store);
                      }}
                    >
                      Catch Field
                    </Typography>
                    <Box sx={{ flexGrow: 1 }}>
                      <Tooltip title="Open Menu">
                        <Button
                          onClick={handleOpenUserMenu}
                          sx={{ my: 2, color: "white", display: "block" }}
                          variant="outlined"
                        >
                          Actions
                        </Button>
                      </Tooltip>
                      <Menu
                        sx={{ mt: "45px" }}
                        id="menu-appbar"
                        anchorEl={anchorElUser}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        open={Boolean(anchorElUser)}
                        onClose={handleCloseUserMenu}
                      >
                        <MenuItem onClick={handleCloseUserMenu}>
                          <Typography
                            textAlign="center"
                            onClick={() =>
                              navigate(
                                `/Missing-Devices-Report/` +
                                params.retailer +
                                "/" +
                                params.store
                              )
                            }
                          >
                            Missing Devices
                          </Typography>
                        </MenuItem>
                        <MenuItem onClick={handleCloseUserMenu}>
                          <Typography
                            textAlign="center"
                            onClick={moveToMultiPhotoes}
                          >
                            Camera
                          </Typography>
                        </MenuItem>
                        <MenuItem onClick={handleCloseUserMenu}>
                          <Typography
                            textAlign="center"
                            onClick={() => setswanSongTrigger(true)}
                          >
                            Multi Swan Song
                          </Typography>
                        </MenuItem>
                        {triggeredSwanSong.length > 0 && (
                          <MenuItem onClick={handleCloseUserMenu}>
                            <Typography
                              textAlign="center"
                              onClick={() => {
                                triggeredSwanSong.forEach((deviceId) => {
                                  window.open(`/SwanSong/${deviceId}`, '_blank');
                                  console.log(`Opened tab for device: ${deviceId}`);
                                });
                              }}
                            >
                              Show SS Results
                            </Typography>
                          </MenuItem>
                        )}
                        <MenuItem onClick={handleCloseUserMenu}>
                          <Typography textAlign="center" onClick={moveToRealTime}>
                            Real Time
                          </Typography>
                        </MenuItem>
                        {ispermitted && (
                          <MenuItem onClick={handleCloseUserMenu}>
                            <Typography textAlign="center" onClick={() => {
                              window.open(
                                `/UserManagement`,
                                "_blank"
                              )
                            }}>
                              User Management
                            </Typography>
                          </MenuItem>
                        )}
                        <MenuItem onClick={handleCloseUserMenu}>
                          <Typography textAlign="center" onClick={moveToWifiReport}>
                            WiFi Report
                          </Typography>
                        </MenuItem>
                        {/* <MenuItem onClick={handleCloseUserMenu}>
                          <Typography
                            textAlign="center"
                            onClick={() =>
                              window.open(`${configData.SERVER_URL}:3002`, "_blank")
                            }
                          >
                            Notification system
                          </Typography>
                        </MenuItem> */}
                        <MenuItem onClick={handleCloseUserMenu}>
                          <Typography
                            textAlign="center"
                            onClick={() =>
                              window.open(
                                `${configData.SERVER_URL}:3001/`,
                                "_blank"
                              )
                            }
                          >
                            Dashboard
                          </Typography>
                        </MenuItem>
                      </Menu>
                    </Box>

                    <Box sx={{ flexGrow: 1 }}>
                      <Tooltip title="Select Columns">
                        <Button
                          onClick={handleOpenColumnsMenu}
                          sx={{ my: 2, color: "white", display: "block" }}
                          variant="outlined"
                        >
                          Columns
                        </Button>
                      </Tooltip>
                      <Menu
                        sx={{ mt: "45px" }}
                        id="menu-appbar"
                        anchorEl={anchorElColumns}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        open={Boolean(anchorElColumns)}
                        onClose={handleCloseColumsMenu}
                      >
                        <MenuItem>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <CheckBox
                                  checked={columnForm.serial_number}
                                  name="serial_number"
                                  onChange={handleColumnForm}
                                />
                              }
                              label="Serial Number"
                            />
                          </FormGroup>
                        </MenuItem>
                        <MenuItem>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <CheckBox
                                  checked={columnForm.battery}
                                  name="battery"
                                  onChange={handleColumnForm}
                                />
                              }
                              label="Battery"
                            />
                          </FormGroup>
                        </MenuItem>
                        <MenuItem>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <CheckBox
                                  checked={columnForm.battery_status}
                                  name="battery_status"
                                  onChange={handleColumnForm}
                                />
                              }
                              label="Battery Status"
                            />
                          </FormGroup>
                        </MenuItem>
                        <MenuItem>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <CheckBox
                                  checked={columnForm.battery_temp}
                                  name="battery_temp"
                                  onChange={handleColumnForm}
                                />
                              }
                              label="Battery Temperature"
                            />
                          </FormGroup>
                        </MenuItem>
                        <MenuItem>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <CheckBox
                                  checked={columnForm.wifi}
                                  name="wifi"
                                  onChange={handleColumnForm}
                                />
                              }
                              label="WIFI"
                            />
                          </FormGroup>
                        </MenuItem>
                        <MenuItem>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <CheckBox
                                  checked={columnForm.cart}
                                  name="cart"
                                  onChange={handleColumnForm}
                                />
                              }
                              label="Status + Floor"
                            />
                          </FormGroup>
                        </MenuItem>
                        <MenuItem>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <CheckBox
                                  checked={columnForm.tablet_status}
                                  name="tablet_status"
                                  onChange={handleColumnForm}
                                />
                              }
                              label="Tablet Status"
                            />
                          </FormGroup>
                        </MenuItem>
                        <MenuItem>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <CheckBox
                                  checked={columnForm.location_update}
                                  name="location_update"
                                  onChange={handleColumnForm}
                                />
                              }
                              label="Location Update"
                            />
                          </FormGroup>
                        </MenuItem>
                        <MenuItem>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <CheckBox
                                  checked={columnForm.photo}
                                  name="photo"
                                  onChange={handleColumnForm}
                                />
                              }
                              label="Photo"
                            />
                          </FormGroup>
                        </MenuItem>
                        <MenuItem>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <CheckBox
                                  checked={columnForm.show_location}
                                  name="show_location"
                                  onChange={handleColumnForm}
                                />
                              }
                              label="Show Location"
                            />
                          </FormGroup>
                        </MenuItem>
                        <MenuItem>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <CheckBox
                                  checked={columnForm.swan_song}
                                  name="swan_song"
                                  onChange={handleColumnForm}
                                />
                              }
                              label="Swan song"
                            />
                          </FormGroup>
                        </MenuItem>
                        <MenuItem>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <CheckBox
                                  checked={columnForm.beacon}
                                  name="beacon"
                                  onChange={handleColumnForm}
                                />
                              }
                              label="Beacon"
                            />
                          </FormGroup>
                        </MenuItem>
                      </Menu>
                    </Box>

                    <Typography
                      variant="p"
                      noWrap
                      component="div"
                      sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
                    >
                      Total carts: {cartEvents.length}
                    </Typography>
                    <Search>
                      <SearchIconWrapper>
                        <SearchIcon />
                      </SearchIconWrapper>
                      <StyledInputBase
                        placeholder="Search…"
                        inputProps={{ "aria-label": "search" }}
                        onChange={(e) => setSearchCart(e.target.value)}
                      />
                    </Search>
                  </Toolbar>
                </AppBar>
              </Box>
              {checked.length > 0 && (
                <>
                  <Alert
                    severity="success"
                    action={
                      ispermitted ? (
                        <Button color="inherit" size="small" onClick={handleOpenDialog}>
                          Reset Tablets
                        </Button>
                      ) : null
                    }
                  >
                    {checked.length} tablets were selected
                  </Alert>

                  <Dialog open={open} onClose={handleCloseDialog}>
                    <DialogTitle>Confirm Reset</DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        Are you sure you want to reset {checked.join(', ')}?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseDialog} color="primary">
                        Cancel
                      </Button>
                      <Button onClick={handleConfirm} color="primary" autoFocus>
                        Confirm
                      </Button>
                    </DialogActions>
                  </Dialog>
                </>
              )}

              {/* start of table */}

              <Box sx={{ flexGrow: 1, minHeight: 0, display: "flex", flexDirection: "column", paddingBottom: isMobile ? "12%" : 0 }}>
                <TableContainer
                  component={Paper}
                  sx={{
                    height: isMobile ? "70vh" : "85vh",
                    overflowY: "auto",
                    display: "block",
                    boxSizing: "border-box",   // ensure height includes borders/padding
                  }}
                >
                  <Table stickyHeader size="small">

                    <TableHeader
                      valueToOrderBy={valueToOrderBy}
                      orderDirection={orderDirection}
                      handleRequestSort={handleRequestSort}
                      numSelected={checked.length}
                      onSelectAllClick={handleSelectAllClick}
                      rowCount={filteredCarts.length}
                      columnForm={columnForm}
                    />
                    {cartEvents.length > 0 && cartEvents[0]?.sdkSetupId !== "Yaniv-Tablet" ? (
                      <TableBody id="table-row">
                        {sortedRows.map((cart, index) => {
                          const isItemSelected = isSelected(cart.serial_number);
                          const wasItemTriggered = wasTriggered(cart.serial_number)
                          const labelId = `enhanced-table-checkbox-${index}`;

                          return (
                            <CartRow
                              wasItemTriggered={wasItemTriggered}
                              isItemSelected={isItemSelected}
                              labelId={labelId}
                              coordinates={coordinates}
                              event={cart}
                              updateCart={updateCartEvent}
                              key={index}
                              updateCartLocation={updateCartLocation}
                              updateCenter={updateCenter}
                              changeSelectedCart={changeSelectedCart}
                              handleClick={handleClick}
                              columnForm={columnForm}
                            />
                          );
                        })}
                      </TableBody>
                    ) : (
                      <TableBody>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                          <TableCell>
                            <CircularProgress size={48} />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Box>
            </div>
          </Panel>
        </PanelGroup>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default Home;
